module.exports = __webpack_public_path__ + "static/media/muji ui4.747be06c.png";